export default "__VITE_ASSET__CgnU9_Sl__"